import router from "@/router";
import { localCache } from "@/utils/Cache";
const menu = {
  state: {
    // 后台侧边栏
    menuList: [
      {
        name: "场地预约",
        url: "/venueReservation",
        icon: require("@/assets/imgs/menu/user.png"),
        img: require("@/assets/imgs/menu/user-on.png"),
        permission: "",
        show: true,
        type: 0,
      },
      {
        name: "预约审核",
        url: "/reservationAudit",
        icon: require("@/assets/imgs/menu/role.png"),
        img: require("@/assets/imgs/menu/role-on.png"),
        permission: "",
        show: true,
        type: 0,
      },
      {
        name: "配套设施",
        url: "/supportingFacilities",
        icon: require("@/assets/imgs/menu/dept.png"),
        img: require("@/assets/imgs/menu/dept-on.png"),
        permission: "",
        show: true,
        type: 0,
      },
      {
        name: "个性设置",
        url: "/personalizedSettings",
        icon: require("@/assets/imgs/menu/menu.png"),
        img: require("@/assets/imgs/menu/menu-on.png"),
        permission: "",
        show: true,
        type: 0,
      },
    ],
    // 首页菜单
    homeMenu: [
      {
        label: "校友管理",
        path: "/alumni",
        parentPath: "/alumniManagement",
        name: "alumni",
        icon: require("@/assets/imgs/menu/xy.png"),
        color: "#E2F7F4",
        permission: "/alumni",
        show: false,
        iconShow: true,
      },
    ],
    collapsed: false,
    menuChildrenList: [],
    activeIcon: "",
    homeTitle: "场地预约",
    imgUrl: require("@/assets/imgs/venue.png"),
    loginUrl: process.env.VUE_APP_BASE_API,
    // ownUrl: "http://192.168.0.53:9118/",
    ownUrl: "https://www.mingxiaobang.cn/sccpPlatform/",// 初始pc平台
    ysxyUrl: "https://www.mingxiaobang.cn/cdysxy/sccp/",// 艺术学院pc平台
    msxyUrl: "https://www.mingxiaobang.cn/cdmsxy/sccp/",// 美视电影学院pc平台
  },

  getters: {},
  mutations: {
    setTitle(state, val) {
      state.homeTitle = val.label;
      state.imgUrl = val.url;
      sessionStorage.setItem("asideTitle", JSON.stringify(val));
    },
    // 修改一级侧边栏展开收起
    changeCollapsed(state) {
      state.collapsed = !state.collapsed;
    },
    childMenu(state, val) {
      state.menuList.forEach((item) => {
        if (val.name == item.name) {
          state.menuChildrenList = item.children;
          localCache.setCache(
            "menuChildrenList",
            JSON.stringify(item.children)
          );
        }
      });
    },
    setMenu(state) {
      let permission = JSON.parse(sessionStorage.getItem("m"));
      state.menuList.forEach((item) => {
        if (item.children) {
          item.children.forEach((om) => {
            if (permission?.includes(om.permission)) {
              om.show = true;
            } else {
              om.show = false;
            }
          });
        } else {
          if (permission?.includes(item.permission)) {
            item.show = true;
          } else {
            item.show = false;
          }
        }
      });
      if (state.menuList?.filter((f) => f.show)?.length) {
        //权限第一个元素有children
        const routeList = router.options.routes[0];
        if (state.menuList?.filter((f) => f.show)?.[0]?.children?.length) {
          routeList.redirect = state.menuList?.filter(
            (f) => f.show
          )?.[0]?.children?.[0]?.url;
          // localCache.setCache(
          //   "activeParentIndex",
          //   state.menuList?.filter((f) => f.show)?.[0]?.children?.[0]?.parentPath
          // );
          // 实现父级图标高亮
        } else {
          // localCache.setCache(
          //   "activeIndex",
          //   state.menuList?.filter((f) => f.show)?.[0]?.path
          // );
          routeList.redirect = state.menuList?.filter((f) => f.show)?.[0]?.url;
        }
      }
    },
    setIcon(state, val) {
      state.activeIcon = val;
    },
  },
  actions: {},
};
export default menu;
